import React from 'react';
import { Link } from 'react-router-dom';
import { Atom } from 'lucide-react';
import Logo from '../components/Logo';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <Logo className="w-24 h-24 mx-auto mb-6" />
        <h1 className="text-6xl font-bold text-[#EC6224] mb-4">404</h1>
        <div className="bg-white rounded-lg shadow-lg p-8">
          <Atom className="w-12 h-12 text-[#EC6224] mx-auto mb-4 animate-spin" />
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Quantum Superposition Error
          </h2>
          <p className="text-gray-600 mb-6">
            This page exists in a state of both being and not being, but when we tried to observe it,
            the waveform collapsed and we couldn't find what you were looking for.
          </p>
          <Link 
            to="/"
            className="inline-flex items-center px-6 py-3 bg-[#EC6224] text-white rounded-lg hover:bg-[#232323] transition-colors"
          >
            Return to Known Space
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;